import { render, staticRenderFns } from "./Covid.vue?vue&type=template&id=10d76dd8&"
import script from "./Covid.vue?vue&type=script&lang=ts&"
export * from "./Covid.vue?vue&type=script&lang=ts&"
import style0 from "./Covid.vue?vue&type=style&index=0&id=10d76dd8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports